
import util from '../../../util/Util';
export default {
  props: {
    filterProp: {
      type: Object,
      default: ()=>{}
    }
  },
  data() {
    return {
      selectedType: 0,
      typeOptions: {
        0: 'Any',
        1: 'Ready now',
        3: 'No set date',
        2: 'Specific date',
      },
      selectedDateType: 'specific',
      filter: {
        fromDate : null,
        toDate : null,
        dateType: 0,
        selectedDateType: 'specific'
      },
      valueString: 'Any'
    };
  },
  watch:{
    filterProp: {
      handler() {
        if (this.filterProp.dateType || this.filterProp?.fromDate || this.filterProp?.toDate) {
          if(this.filterProp?.dateType)
          {
            this.selectedType = parseInt(this.filterProp?.dateType)
          } 
          if(this.filterProp?.selectedDateType)
          {
            this.selectedDateType = this.filterProp?.selectedDateType
          } 
          
          const filtersObj = {
            dateType: this.filterProp.dateType ? parseInt(this.filterProp.dateType): null,
            fromDate: this.filterProp?.fromDate ? this.filterProp?.fromDate: null,
            toDate: this.filterProp?.toDate ? this.filterProp?.toDate: null,
            selectedDateType: this.filterProp?.selectedDateType ? this.filterProp?.selectedDateType: 'specific'
          }

          this.filter = filtersObj
          this.$emit('value-changed', {...this.filterProp})
        }
        else{
          this.filter = {}
          this.filter = {
            fromDate : null,
            toDate : null,
            dateType: 0,
            selectedDateType: 'specific'
          }
          this.selectedType = 0
          this.selectedDateType = 'specific'
          this.$emit('value-changed', {...this.filter})
        }
        this.getValueString()
        
      },
      deep: true,
      immediate: true
    
  },
    filter : {
      handler() {
        this.handleChange();
        },
      deep: true,
      immediate: true
    }
  },
  mounted() {
  },
  methods: {
    handleChange () { 
      if(this.selectedDateType === 'specific'){
        this.filter.toDate =this.filter.fromDate
      }
      this.getValueString()
      this.$emit('value-changed', {...this.filter, dateType:this.selectedType, selectedDateType: this.selectedDateType})
    },
    selectedTypeChanged () { 
      this.filter.fromDate = null;
      this.filter.toDate = null;
      this.filter.dateType = this.selectedType
    },
    getValueString(){
      this.valueString = this.selectedType !== 2 ? this.typeOptions[this.selectedType] : this.selectedDateType === 'specific' ? (this.filter.fromDate? util.formatDate(this.filter.fromDate): 'Any') : (this.filter.fromDate? util.formatDate(this.filter.fromDate) : 'Any') + ' - ' + (this.filter.toDate? util.formatDate(this.filter.toDate) : 'Any')
    },
  }
}
